import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserStarballGame from 'src/games/StarballGame/Main';

interface StarballGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class StarballGame extends React.Component<StarballGameProps> {
    constructor(props: StarballGameProps) {
        super(props);
        bindAllOfThis(this, StarballGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserStarballGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default StarballGame;



// WEBPACK FOOTER //
// ./src/pages/game/StarballGame.tsx